
import React from 'react';
import JobForm from './JobForm';
import JobList from './JobList';
import Card from '../common/Card';

const JobDefinitionTab = () => {
  return (
    <div className="job-definition-tab">
      <Card>
        <h2 className="card-title">➕ Create New Job Position</h2>
        <JobForm />
      </Card>
      <Card>
        <h2 className="card-title">📋 All Job Positions</h2>
        <JobList />
      </Card>
    </div>
  );
};

export default JobDefinitionTab;
